import { ReactElement } from 'react';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineDot from '@mui/lab/TimelineDot';
import { LightGrayLabel } from 'components/labels';
import { Text } from 'components/Text';
import {
  StyledTimeline,
  StyledTimelineContent,
  StyledTimelineItem,
  StyledTimelineSeparator
} from './styledComponents';

export interface BasicTimelineEventData {
  label: string;
  value?: string;
  newValue?: string;
  isLastItem?: boolean;
}

export const BasicTimelineEvent = ({
  label,
  value,
  newValue,
  isLastItem
}: BasicTimelineEventData) => {
  return (
    <StyledTimelineItem key={value}>
      <StyledTimelineSeparator>
        <TimelineDot />
        {!isLastItem && <TimelineConnector />}
      </StyledTimelineSeparator>
      <StyledTimelineContent>
        <Text>{label}</Text>
        <LightGrayLabel crossed={!!newValue}>{value}</LightGrayLabel>
        {newValue && <Text>{newValue}</Text>}
      </StyledTimelineContent>
    </StyledTimelineItem>
  );
};

export const BasicTimeline = ({
  children
}: {
  children: ReactElement[] | ReactElement;
}) => {
  return <StyledTimeline>{children}</StyledTimeline>;
};
